import { render, staticRenderFns } from "./componente.vue?vue&type=template&id=2759ebe1&scoped=true&"
import script from "./componente.vue?vue&type=script&lang=js&"
export * from "./componente.vue?vue&type=script&lang=js&"
import style0 from "./componente.vue?vue&type=style&index=0&lang=css&"
import style1 from "./componente.vue?vue&type=style&index=1&id=2759ebe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759ebe1",
  null
  
)

export default component.exports